import { render } from "./BoardSelect.vue?vue&type=template&id=0f159c67"
import script from "./BoardSelect.vue?vue&type=script&lang=js"
export * from "./BoardSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__